<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <main class="common-main">
      <!-- 認証済みの時はメインの画面を表示 -->
      <template v-if="signedIn">
        <template v-if="isLoading">
          <div class="loading"></div>
        </template>
        <template v-else-if="isStaff">
          <h2 class="common-title">アカウント情報の登録</h2>
          <dl class="item">
            <dt class="profile-title">メールアドレス</dt>
            <dd class="profile-input">
              <input type="text" v-model="mailaddress" placeholder="メールアドレス" disabled />
            </dd>
            <dd class="profile-textSmall">メールアドレスは変更できません</dd>
          </dl>
          <dl class="item">
          運営アカウントはプロフィール設定不要
          </dl>
        </template>
        <template v-else>
          <dl class="item">
            <a href="/dashboard">
              <button class="footerNavi-button button-secondary">
                ダッシュボードに戻る
              </button>
            </a>
          </dl>
          <template v-if="hasUserData">
            <h2 class="common-title">アカウント情報の更新</h2>
          </template>
          <template v-else>
            <h2 class="common-title">アカウント情報の登録</h2>
          </template>
          <div class="item">※登録されたアカウント情報の利用用途・開示先に関しては <a href="./terms">利用規約</a>・<a href="./privacy">プライバシーポリシー</a>・<a href="./help">ヘルプ</a> をご確認ください</div>
          <dl class="item">
            <dt class="profile-title">メールアドレス<span class="must-label">変更不可</span></dt>
            <dd class="profile-input">
              <input type="text" v-model="mailaddress" placeholder="メールアドレス" disabled />
            </dd>
            <dd class="profile-textSmall">メールアドレスは変更できません</dd>
          </dl>

          <dl class="item">
            <h3>必須項目</h3>
            年齢や居住地に応じて、あなたの状況に適した返信を得やすくなります。
          </dl>

          <dl class="item">
            <dt class="profile-title">表示名<span class="must-label">必須</span></dt>
            <dd class="profile-input">
              <input type="text" v-model="displayName" placeholder="表示名" maxlength="20" />
            </dd>
            <dd class="profile-textSmall">{{displayName.length}} / 20文字</dd>
          </dl>

          <dl class="item">
            <dt class="profile-title">生年月日<span class="must-label">必須</span></dt>
            <dd class="profile-input">
              <input type="date" v-model="birthDate" placeholder="YYYY-MM-DD" />
            </dd>
            <dd class="profile-textSmall">年月をクリック/タップすることで、任意の年もしくは月を指定できます</dd>
          </dl>

          <dl class="item">
            <dt class="profile-title">性別<span class="must-label">必須</span></dt>
            <dd class="profile-input">
              <ul class="radiobox-list">
                <li>
                  <input
                    id="radio-gender-男性"
                    class="input-marker"
                    v-model="gender"
                    name="gender"
                    type="radio"
                    value="男性"
                  />
                  <label for="radio-gender-男性">男性</label>
                </li>
                <li>
                  <input
                    id="radio-gender-女性"
                    class="input-marker"
                    v-model="gender"
                    name="gender"
                    type="radio"
                    value="女性"
                  />
                  <label for="radio-gender-女性">女性</label>
                </li>
                <li>
                  <input
                    id="radio-gender-その他"
                    class="input-marker"
                    v-model="gender"
                    name="gender"
                    type="radio"
                    value="その他"
                  />
                  <label for="radio-gender-その他">その他</label>
                </li>
              </ul>
            </dd>
          </dl>

          <dl class="item">
            <dt class="profile-title">郵便番号（ハイフンなし）<span class="must-label">必須</span></dt>
            <dd class="profile-input">
              <input v-model="postalCode" placeholder="1010001" v-bind:disabled="isNotLiveInJapan" type="text"/>
              <label class="label-textSmall"
                ><input v-model="isNotLiveInJapan" type="checkbox" v-on:change="changeLiveInJapan" /> 海外在住</label
              >
            </dd>
          </dl>

          <dl v-if="appClass === 'hama'" class="item">
            <dt class="profile-title">研究（アンケート調査）への同意<span class="must-label">必須</span></dt>
            <dd class="profile-input">
              <select v-model="consentHamaMEDResearch" name="consentHamaMEDResearch" style="padding: 5px">
                <option value="agree">同意します</option>
                <option value="disagree">同意しません</option>
              </select>
            </dd>
            <dd class="profile-textSmall"><a href="./consent" target="_blank"><strong>「インターネットを利用したオンラインがん相談に関する研究」ご協力のお願い</strong></a></dd>
            
          </dl>

          <dl v-if="appClass === 'hama'" class="item">
            <dt class="profile-title">浜松医科大学医学部附属病院の診察券番号</dt>
            <dd class="profile-input">
              <input type="text" v-model="patientIdHamaMEDHospital" placeholder="浜松医科大学医学部附属病院の診察券番号" maxlength="20" />
            </dd>
            <dd class="profile-textSmall">「浜松医科大学医学部附属病院」の診察券番号を入力してください。他の病院・クリニックの診察券番号は入力しないでください。</dd>
          </dl>

          <dl class="item">
            <button @click="showDetail = !showDetail">
              詳細設定
            </button>
          </dl>
          <transition name="fadeDetail">
            <div v-if="showDetail">
                <dl class="item">
                  <h3>詳細設定</h3>
                  がん種やステージ、経過年数を入力することで、あなたの現状に適した回答を得やすくなります。治療状況に変化があった場合、アップデートすることをおすすめします。
                </dl>

                <dl class="item">
                  <dt class="profile-title">姓</dt>
                  <dd class="profile-input">
                    <input type="text" v-model="lastName" placeholder="姓" maxlength="10" />
                  </dd>
                  <dd class="profile-textSmall">【任意】<template v-if="lastName">{{lastName.length}}</template><template v-else>0</template> / 10文字</dd>
                </dl>

                <dl class="item">
                  <dt class="profile-title">名</dt>
                  <dd class="profile-input">
                    <input type="text" v-model="firstName" placeholder="名" maxlength="10" />
                  </dd>
                  <dd class="profile-textSmall">【任意】<template v-if="firstName">{{firstName.length}}</template><template v-else>0</template> / 10文字</dd>
                </dl>

                <!-- ユーザー必須、アドバイザー無し-->
                <dl class="item" v-if="isAdviser">
                </dl>
                <dl class="item" v-else>
                  <dt class="profile-title">続柄</dt>
                  <dd class="profile-input">
                    <ul class="radiobox-list">
                      <li>
                        <input
                          id="radio-relationship-がん患者（サバイバー含む）"
                          class="input-marker"
                          v-model="relationship"
                          name="relationship"
                          type="radio"
                          value="がん患者（サバイバー含む）"
                        />
                        <label for="radio-relationship-がん患者（サバイバー含む）">がん患者（サバイバー含む）</label>
                      </li>
                      <li>
                        <input
                          id="radio-relationship-がん患者の家族"
                          class="input-marker"
                          v-model="relationship"
                          name="relationship"
                          type="radio"
                          value="がん患者の家族"
                        />
                        <label for="radio-relationship-がん患者の家族">がん患者の家族</label>
                      </li>
                      <li>
                        <input
                          id="radio-relationship-がん患者の友人"
                          class="input-marker"
                          v-model="relationship"
                          name="relationship"
                          type="radio"
                          value="がん患者の友人"
                        />
                        <label for="radio-relationship-がん患者の友人">がん患者の友人</label>
                      </li>
                      <li>
                        <input
                          id="radio-relationship-医療従事者"
                          class="input-marker"
                          v-model="relationship"
                          name="relationship"
                          type="radio"
                          value="医療従事者"
                        />
                        <label for="radio-relationship-医療従事者">医療従事者</label>
                      </li>
                      <li>
                        <input
                          id="radio-relationship-その他"
                          class="input-marker"
                          v-model="relationship"
                          name="relationship"
                          type="radio"
                          value="その他"
                        />
                        <label for="radio-relationship-その他">その他</label>
                      </li>
                    </ul>
                  </dd>
                </dl>
                
                <dl class="item">
                  <!-- アドバイザー -->
                  <dt class="profile-title" v-if="isAdviser">回答可能ながん種</dt>
                  <!-- ユーザー -->
                  <dt class="profile-title" v-else>現在相談したいがん種</dt>
                  <dt class="profile-subtitle">{{cancerType1Label}}</dt>
                  <dd class="profile-input">
                    <ul class="radiobox-list">
                      <li v-for="cancerType in cancerType1" :key="cancerType">
                        <input
                          :id="'radio-cancerType-' + cancerType.name"
                          class="input-marker"
                          v-model="checkedCancerTypes"
                          type="checkbox"
                          v-bind:value="cancerType.name"
                        />
                        <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                      </li>
                    </ul>
                  </dd>

                  <dt class="profile-subtitle">{{cancerType2Label}}</dt>
                  <button @click="showCancerType2_1 = !showCancerType2_1" class="profile-button">
                    {{cancerType2_1Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_1">
                      <dd class="profile-input" v-if="showCancerType2_1">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_1" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_2 = !showCancerType2_2" class="profile-button">
                    {{cancerType2_2Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_2">
                      <dd class="profile-input" v-if="showCancerType2_2">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_2" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_3 = !showCancerType2_3" class="profile-button">
                    {{cancerType2_3Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_3">
                      <dd class="profile-input" v-if="showCancerType2_3">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_3" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_4 = !showCancerType2_4" class="profile-button">
                    {{cancerType2_4Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_4">
                      <dd class="profile-input" v-if="showCancerType2_4">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_4" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_5 = !showCancerType2_5" class="profile-button">
                    {{cancerType2_5Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_5">
                      <dd class="profile-input" v-if="showCancerType2_5">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_5" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_6 = !showCancerType2_6" class="profile-button">
                    {{cancerType2_6Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_6">
                      <dd class="profile-input" v-if="showCancerType2_6">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_6" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_7 = !showCancerType2_7" class="profile-button">
                    {{cancerType2_7Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_7">
                      <dd class="profile-input" v-if="showCancerType2_7">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_7" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_8 = !showCancerType2_8" class="profile-button">
                    {{cancerType2_8Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_8">
                      <dd class="profile-input" v-if="showCancerType2_8">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_8" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_9 = !showCancerType2_9" class="profile-button">
                    {{cancerType2_9Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_9">
                      <dd class="profile-input" v-if="showCancerType2_9">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_9" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_10 = !showCancerType2_10" class="profile-button">
                    {{cancerType2_10Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_10">
                      <dd class="profile-input" v-if="showCancerType2_10">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_10" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_11 = !showCancerType2_11" class="profile-button">
                    {{cancerType2_11Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_11">
                      <dd class="profile-input" v-if="showCancerType2_11">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_11" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_12 = !showCancerType2_12" class="profile-button">
                    {{cancerType2_12Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_12">
                      <dd class="profile-input" v-if="showCancerType2_12">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_12" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_13 = !showCancerType2_13" class="profile-button">
                    {{cancerType2_13Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_13">
                      <dd class="profile-input" v-if="showCancerType2_13">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_13" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_14 = !showCancerType2_14" class="profile-button">
                    {{cancerType2_14Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_14">
                      <dd class="profile-input" v-if="showCancerType2_14">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_14" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_15 = !showCancerType2_15" class="profile-button">
                    {{cancerType2_15Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_15">
                      <dd class="profile-input" v-if="showCancerType2_15">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_15" :key="cancerType">
                            <input
                              :id="'radio-cancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedCancerTypes"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-cancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>
                </dl>
                
                <!-- ユーザー必須、アドバイザー無し-->
                <dl class="item" v-if="isAdviser">
                </dl>
                <dl class="item" v-else>
                  <dt class="profile-title">ステージ</dt>
                  <dd class="profile-input">
                    <ul class="radiobox-list">
                      <li>
                        <input
                          id="radio-cancerStage-不明"
                          class="input-marker"
                          v-model="cancerStage"
                          name="cancerStage"
                          type="radio"
                          value="不明"
                        />
                        <label for="radio-cancerStage-不明">不明</label>
                      </li>
                      <li>
                        <input
                          id="radio-cancerStage-ステージ0"
                          class="input-marker"
                          v-model="cancerStage"
                          name="cancerStage"
                          type="radio"
                          value="ステージ0"
                        />
                        <label for="radio-cancerStage-ステージ0">ステージ0</label>
                      </li>
                      <li>
                        <input
                          id="radio-cancerStage-ステージI"
                          class="input-marker"
                          v-model="cancerStage"
                          name="cancerStage"
                          type="radio"
                          value="ステージI"
                        />
                        <label for="radio-cancerStage-ステージI">ステージI</label>
                      </li>
                      <li>
                        <input
                          id="radio-cancerStage-ステージII"
                          class="input-marker"
                          v-model="cancerStage"
                          name="cancerStage"
                          type="radio"
                          value="ステージII"
                        />
                        <label for="radio-cancerStage-ステージII">ステージII</label>
                      </li>
                      <li>
                        <input
                          id="radio-cancerStage-ステージIII"
                          class="input-marker"
                          v-model="cancerStage"
                          name="cancerStage"
                          type="radio"
                          value="ステージIII"
                        />
                        <label for="radio-cancerStage-ステージIII">ステージIII</label>
                      </li>
                      <li>
                        <input
                          id="radio-cancerStage-ステージIV"
                          class="input-marker"
                          v-model="cancerStage"
                          name="cancerStage"
                          type="radio"
                          value="ステージIV"
                        />
                        <label for="radio-cancerStage-ステージIV">ステージIV</label>
                      </li>
                      <li>
                        <input
                          id="radio-cancerStage-転移性"
                          class="input-marker"
                          v-model="cancerStage"
                          name="cancerStage"
                          type="radio"
                          value="転移性"
                        />
                        <label for="radio-cancerStage-転移性">転移性</label>
                      </li>
                      <li>
                        <input
                          id="radio-cancerStage-その他"
                          class="input-marker"
                          v-model="cancerStage"
                          name="cancerStage"
                          type="radio"
                          value="その他"
                        />
                        <label for="radio-cancerStage-その他">その他</label>
                      </li>
                    </ul>
                  </dd>
                </dl>
                
                <!-- ユーザー必須、アドバイザー無し-->
                <dl class="item" v-if="isAdviser">
                </dl>
                <dl class="item" v-else>
                  <!-- TODO：診断前の場合は？ -->
                  <dt class="profile-title">がんと診断された年月日</dt>
                  <dd class="profile-input">
                    <input type="date" v-model="diagnosedDate" placeholder="YYYY-MM-DD" />
                  </dd>
                  <dd class="profile-textSmall">年月をクリック/タップすることで、任意の年もしくは月を指定できます</dd>
                </dl>

                <!-- ユーザー必須、アドバイザー無し-->
                <dl class="item" v-if="isAdviser">
                </dl>
                <dl class="item" v-else>
                  <!-- TODO：診断前の場合は？ -->
                  <dt class="profile-title">がんが発見されたきっかけ</dt>
                  <dd class="profile-input">
                    <textarea v-model="diagnosedReason" placeholder="自由記述" maxlength="200"></textarea>
                  </dd>
                  <dd class="profile-textSmall"><template v-if="diagnosedReason">{{diagnosedReason.length}}</template><template v-else>0</template> / 200文字</dd>
                </dl>
                
                <!-- ユーザー必須、アドバイザー無し-->
                <dl class="item" v-if="isAdviser">
                </dl>
                <dl class="item" v-else>
                  <!-- TODO：通院前の場合は？ -->
                  <dt class="profile-title">現在かかっている病院・診療科</dt>
                  <dd class="profile-input">
                    <input type="text" v-model="hospitalName" placeholder="◯◯病院" maxlength="30" />
                  </dd>
                  <dd class="profile-textSmall"><template v-if="hospitalName">{{hospitalName.length}}</template><template v-else>0</template> / 30文字</dd>
                </dl>

                <!-- ユーザー必須、アドバイザー無し-->
                <dl class="item" v-if="isAdviser">
                </dl>
                <dl class="item" v-else>
                  <dt class="profile-title">現在の状況</dt>
                  <dd class="profile-input">
                    <ul class="radiobox-list">
                      <li>
                        <input
                          id="radio-curativeStatus-不明"
                          class="input-marker"
                          v-model="curativeStatus"
                          name="curativeStatus"
                          type="radio"
                          value="不明"
                        />
                        <label for="radio-curativeStatus-不明">不明</label>
                      </li>
                      <li>
                        <input
                          id="radio-curativeStatus-診断・告知前"
                          class="input-marker"
                          v-model="curativeStatus"
                          name="curativeStatus"
                          type="radio"
                          value="診断・告知前"
                        />
                        <label for="radio-curativeStatus-診断・告知前">診断・告知前</label>
                      </li>
                      <li>
                        <input
                          id="radio-curativeStatus-治療前"
                          class="input-marker"
                          v-model="curativeStatus"
                          name="curativeStatus"
                          type="radio"
                          value="治療前"
                        />
                        <label for="radio-curativeStatus-治療前">治療前</label>
                      </li>
                      <li>
                        <input
                          id="radio-curativeStatus-治療中（初回）"
                          class="input-marker"
                          v-model="curativeStatus"
                          name="curativeStatus"
                          type="radio"
                          value="治療中（初回）"
                        />
                        <label for="radio-curativeStatus-治療中（初回）">治療中（初回）</label>
                      </li>
                      <li>
                        <input
                          id="radio-curativeStatus-治療中（再発）"
                          class="input-marker"
                          v-model="curativeStatus"
                          name="curativeStatus"
                          type="radio"
                          value="治療中（再発）"
                        />
                        <label for="radio-curativeStatus-治療中（再発）">治療中（再発）</label>
                      </li>
                      <li>
                        <input
                          id="radio-curativeStatus-治療完了"
                          class="input-marker"
                          v-model="curativeStatus"
                          name="curativeStatus"
                          type="radio"
                          value="治療完了"
                        />
                        <label for="radio-curativeStatus-治療完了">治療完了</label>
                      </li>
                      <li>
                        <input
                          id="radio-curativeStatus-継続治療中（ホルモン療法、免疫療法ほか）"
                          class="input-marker"
                          v-model="curativeStatus"
                          name="curativeStatus"
                          type="radio"
                          value="継続治療中（ホルモン療法、免疫療法ほか）"
                        />
                        <label for="radio-curativeStatus-継続治療中（ホルモン療法、免疫療法ほか）">継続治療中（ホルモン療法、免疫療法ほか）</label>
                      </li>
                      <li>
                        <input
                          id="radio-curativeStatus-その他"
                          class="input-marker"
                          v-model="curativeStatus"
                          name="curativeStatus"
                          type="radio"
                          value="その他"
                        />
                        <label for="radio-curativeStatus-その他">その他</label>
                      </li>
                    </ul>
                  </dd>
                </dl>
                
                <!-- ユーザー無し、アドバイザー任意-->
                <dl class="item" v-if="isAdviser">
                  <dt class="profile-title">罹患歴のあるがん種</dt>
                  <dt class="profile-subtitle">{{cancerType1Label}}</dt>
                  <dd class="profile-input">
                    <ul class="radiobox-list">
                      <li v-for="cancerType in cancerType1" :key="cancerType">
                        <input
                          :id="'radio-diagnosedCancerType-' + cancerType.name"
                          class="input-marker"
                          v-model="checkedDiagnosedCancerType"
                          type="checkbox"
                          v-bind:value="cancerType.name"
                        />
                        <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                      </li>
                    </ul>
                  </dd>

                  <dt class="profile-subtitle">{{cancerType2Label}}</dt>
                  <button @click="showCancerType2_1 = !showCancerType2_1" class="profile-button">
                    {{cancerType2_1Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_1">
                      <dd class="profile-input" v-if="showCancerType2_1">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_1" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_2 = !showCancerType2_2" class="profile-button">
                    {{cancerType2_2Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_2">
                      <dd class="profile-input" v-if="showCancerType2_2">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_2" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_3 = !showCancerType2_3" class="profile-button">
                    {{cancerType2_3Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_3">
                      <dd class="profile-input" v-if="showCancerType2_3">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_3" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_4 = !showCancerType2_4" class="profile-button">
                    {{cancerType2_4Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_4">
                      <dd class="profile-input" v-if="showCancerType2_4">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_4" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_5 = !showCancerType2_5" class="profile-button">
                    {{cancerType2_5Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_5">
                      <dd class="profile-input" v-if="showCancerType2_5">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_5" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_6 = !showCancerType2_6" class="profile-button">
                    {{cancerType2_6Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_6">
                      <dd class="profile-input" v-if="showCancerType2_6">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_6" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_7 = !showCancerType2_7" class="profile-button">
                    {{cancerType2_7Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_7">
                      <dd class="profile-input" v-if="showCancerType2_7">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_7" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_8 = !showCancerType2_8" class="profile-button">
                    {{cancerType2_8Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_8">
                      <dd class="profile-input" v-if="showCancerType2_8">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_8" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_9 = !showCancerType2_9" class="profile-button">
                    {{cancerType2_9Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_9">
                      <dd class="profile-input" v-if="showCancerType2_9">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_9" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_10 = !showCancerType2_10" class="profile-button">
                    {{cancerType2_10Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_10">
                      <dd class="profile-input" v-if="showCancerType2_10">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_10" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_11 = !showCancerType2_11" class="profile-button">
                    {{cancerType2_11Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_11">
                      <dd class="profile-input" v-if="showCancerType2_11">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_11" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_12 = !showCancerType2_12" class="profile-button">
                    {{cancerType2_12Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_12">
                      <dd class="profile-input" v-if="showCancerType2_12">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_12" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_13 = !showCancerType2_13" class="profile-button">
                    {{cancerType2_13Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_13">
                      <dd class="profile-input" v-if="showCancerType2_13">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_13" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_14 = !showCancerType2_14" class="profile-button">
                    {{cancerType2_14Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_14">
                      <dd class="profile-input" v-if="showCancerType2_14">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_14" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>

                  <button @click="showCancerType2_15 = !showCancerType2_15" class="profile-button">
                    {{cancerType2_15Label}}
                  </button>
                  <div class="profile-button">
                    <transition name="cancerType2_15">
                      <dd class="profile-input" v-if="showCancerType2_15">
                        <ul class="radiobox-list">
                          <li v-for="cancerType in cancerType2_15" :key="cancerType">
                            <input
                              :id="'radio-diagnosedCancerType-' + cancerType.name"
                              class="input-marker"
                              v-model="checkedDiagnosedCancerType"
                              type="checkbox"
                              v-bind:value="cancerType.name"
                            />
                            <label :for="'radio-diagnosedCancerType-' + cancerType.name">{{cancerType.name}}</label>
                          </li>
                        </ul>
                      </dd>
                    </transition>
                  </div>
                </dl>
                <dl class="item" v-else>
                </dl>
                
                <!-- ユーザー無し、アドバイザー必須-->
                <dl class="item" v-if="isAdviser">
                  <dt class="profile-title">専門分野</dt>
                  <dd class="profile-input">
                    <input type="text" v-model="specialty" placeholder="専門分野" maxlength="50" />
                  </dd>
                  <dd class="profile-textSmall"><template v-if="specialty">{{specialty.length}}</template><template v-else>0</template> / 50文字</dd>
                </dl>
                <dl class="item" v-else>
                </dl>
                
                <!-- ユーザー無し、アドバイザー必須-->
                <dl class="item" v-if="isAdviser">
                  <dt class="profile-title">所属</dt>
                  <dd class="profile-input">
                    <input type="text" v-model="affiliation" placeholder="所属" maxlength="50" />
                  </dd>
                  <dd class="profile-textSmall"><template v-if="affiliation">{{affiliation.length}}</template><template v-else>0</template> / 50文字</dd>
                </dl>
                <dl class="item" v-else>
                </dl>
                
                <!-- ユーザー無し、アドバイザー必須-->
                <dl class="item" v-if="isAdviser">
                  <dt class="profile-title">肩書</dt>
                  <dd class="profile-input">
                    <input type="text" v-model="businessTitle" placeholder="肩書" maxlength="50" />
                  </dd>
                  <dd class="profile-textSmall"><template v-if="businessTitle">{{businessTitle.length}}</template><template v-else>0</template> / 50文字</dd>
                </dl>
                <dl class="item" v-else>
                </dl>
                
                <!-- ユーザー無し、アドバイザー任意-->
                <dl class="item" v-if="isAdviser">
                  <dt class="profile-title">資格</dt>
                  <dd class="profile-input">
                    <input type="text" v-model="licentiate" placeholder="資格" maxlength="50" />
                  </dd>
                  <dd class="profile-textSmall"><template v-if="licentiate">{{licentiate.length}}</template><template v-else>0</template> / 50文字</dd>
                </dl>
                <dl class="item" v-else>
                </dl>
                
                <!-- ユーザー無し、アドバイザー必須-->
                <dl class="item" v-if="isAdviser">
                  <dt class="profile-title">プロフィール</dt>
                  <dd class="profile-input">
                    <textarea v-model="profile" placeholder="自由記述" maxlength="400"></textarea>
                  </dd>
                  <dd class="profile-textSmall"><template v-if="profile">{{profile.length}}</template><template v-else>0</template> / 400文字</dd>
                </dl>
                <dl class="item" v-else>
                </dl>
                
                <dl class="item">
                  <dt class="profile-title">写真・アイコン</dt>
                  <dd class="profile-input">
                    <div class="profile-input-image avator-image">
                      <template v-if="iconImageKey">
                        <img :src="uploadedImage" width="150"/>
                      </template>
                      <template v-else>
                        <img :src="iconDefaultUrl" width="150"/>
                      </template>
                    </div>
                    <div v-show="isUploadImageProcessing" class="loading"></div>
                    <input type="file" @change="upload" id="file" accept="image/*">
                  </dd>
                </dl>
            </div>
          </transition>






          <div class="content-footerNavi">
            <template v-if="hasUserData">
              <button class="footerNavi-button" v-bind:class="{'button-primary':isActiveButtonPrimary, 'button-disabled':isActiveButtonDisabled}" v-on:click="updateUserData()">
                更新
              </button>
            </template>

            <template v-else>
              <button class="footerNavi-button" v-bind:class="{'button-primary':isActiveButtonPrimary, 'button-disabled':isActiveButtonDisabled}" v-on:click="createUserData()">
                保存
              </button>
              <!-- <button class="footerNavi-button button-disabled">保存</button> -->
            </template>

          </div>
          <!-- 
          TODO：必須項目が埋まっていない場合ボタンをdisabledに
          退会導線追加？
          -->
        </template>
      </template>

      <!-- 認証していない時はログイン画面を表示 -->
      <template v-else>
        <LoginItem :createButton="false" />
      </template>
    </main>
    <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { API, Auth, Storage, graphqlOperation, Analytics, Logger } from 'aws-amplify'
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'

import { listUsersBySpecificUser } from './graphql/queries'
import { listAdviserAllowListsBySpecificUser } from './graphql/queries'
import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { listInvitationAllowListsBySpecificUser } from './graphql/queries'
import { createUser } from './graphql/mutations'
import { updateUser } from './graphql/mutations'
import { createErrorLog } from "./graphql/mutations"
import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

const logger = new Logger('ProfileSetting');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'profileSetting',
  components: {
    HeaderItem,
    FooterItem,
    LoginItem
  },
  mixins:[Common],
  data() {
    return {
      authState: undefined,
      unsubscribeAuth: undefined,
      signedIn: false,
      id: '',
      mailaddress: '',
      userType: '',
      isAdviser: false,
      isStaff: false,
      hasUserData: false,
      isNotLiveInJapan: false,
      checkedCancerTypes: [],
      checkedDiagnosedCancerType: [],
      cancerType1Label: '日本人に多いがん',
      cancerType1: [
        {id: 1, name: '肺がん'},
        {id: 2, name: '乳がん'},
        {id: 3, name: '食道がん'},
        {id: 4, name: '胃がん'},
        {id: 5, name: '大腸がん（結腸がん・直腸がん）'},
        {id: 6, name: '肝細胞がん'},
        {id: 7, name: '膵臓がん'},
        {id: 8, name: '膀胱がん'},
        {id: 9, name: '前立腺がん'},
        {id: 10, name: '子宮頸がん'}
      ],
      cancerType2Label: '部位・臓器別',
      cancerType2_1Label: '脳・神経・眼',
      cancerType2_1: [
        {id: 1, name: '脳腫瘍〈成人〉'},
        {id: 2, name: '神経膠腫（グリオーマ）'},
        {id: 3, name: '眼腫瘍'}
      ],
      cancerType2_2Label: '口・のど・鼻・耳',
      cancerType2_2: [
        {id: 1, name: '口腔がん'},
        {id: 2, name: '舌がん'},
        {id: 3, name: '上咽頭がん'},
        {id: 4, name: '中咽頭がん'},
        {id: 5, name: '下咽頭がん'},
        {id: 6, name: '喉頭がん'},
        {id: 7, name: '甲状腺がん'},
        {id: 8, name: '聴器がん'},
        {id: 9, name: '腺様嚢胞がん'},
        {id: 10, name: '嗅神経芽細胞腫'},
        {id: 11, name: '頭頸部の肉腫'}
      ],
      cancerType2_3Label: '胸部',
      cancerType2_3: [
        {id: 1, name: '肺がん'},
        {id: 2, name: '乳がん'},
        {id: 3, name: '胸腺腫・胸腺がん'},
        {id: 4, name: '悪性胸膜中皮腫'},
        {id: 5, name: '体幹の肉腫'},
        {id: 6, name: '肺神経内分泌腫瘍'},
        {id: 7, name: '胸部のSMARCA4欠損腫瘍'}
      ],
      cancerType2_4Label: '消化管',
      cancerType2_4: [
        {id: 1, name: '食道がん'},
        {id: 2, name: '胃がん'},
        {id: 3, name: '大腸がん（結腸がん・直腸がん）'},
        {id: 4, name: '小腸がん（十二指腸がん・空腸がん・回腸がん）'},
        {id: 5, name: 'GIST（消化管間質腫瘍）'},
        {id: 6, name: '膵・消化管神経内分泌腫瘍'}
      ],
      cancerType2_5Label: '肝臓・胆のう・膵臓',
      cancerType2_5: [
        {id: 1, name: '肝細胞がん'},
        {id: 2, name: '胆道がん（胆管がん[肝内胆管がんを含む]・胆のうがん・十二指腸乳頭部がん）'},
        {id: 3, name: '膵臓がん'},
        {id: 4, name: '膵・消化管神経内分泌腫瘍'}
      ],
      cancerType2_6Label: '泌尿器',
      cancerType2_6: [
        {id: 1, name: '腎細胞がん'},
        {id: 2, name: '腎盂・尿管がん'},
        {id: 3, name: '膀胱がん'},
        {id: 4, name: '尿膜管がん'}
      ],
      cancerType2_7Label: 'その他の腹部',
      cancerType2_7: [
        {id: 1, name: '副腎皮質がん'},
        {id: 2, name: '悪性腹膜中皮腫'},
        {id: 3, name: '腹膜がん'},
        {id: 4, name: '後腹膜の肉腫'},
        {id: 5, name: '体幹の肉腫'}
      ],
      cancerType2_8Label: '男性特有のがん',
      cancerType2_8: [
        {id: 1, name: '前立腺がん'},
        {id: 2, name: '胚細胞腫瘍（睾丸がん・精巣がん含む）'}
      ],
      cancerType2_9Label: '女性特有のがん',
      cancerType2_9: [
        {id: 1, name: '乳がん'},
        {id: 2, name: '子宮頸がん'},
        {id: 3, name: '子宮体がん（子宮内膜がん）'},
        {id: 4, name: '子宮肉腫'},
        {id: 5, name: '卵巣がん'},
        {id: 6, name: '腟がん'},
        {id: 7, name: '外陰がん'}
      ],
      cancerType2_10Label: '皮膚',
      cancerType2_10: [
        {id: 1, name: '基底細胞がん'},
        {id: 2, name: '有棘細胞がん'},
        {id: 3, name: '悪性黒色腫（皮膚）'},
        {id: 4, name: '皮膚のリンパ腫'}
      ],
      cancerType2_11Label: '骨と軟部組織（筋肉や脂肪など）',
      cancerType2_11: [
        {id: 1, name: '軟部肉腫〈成人〉'},
        {id: 2, name: 'デスモイド腫瘍'}
      ],
      cancerType2_12Label: '血液・リンパ【白血病】',
      cancerType2_12: [
        {id: 1, name: '急性骨髄性白血病'},
        {id: 2, name: '急性リンパ性白血病・リンパ芽球性リンパ腫'},
        {id: 3, name: '慢性骨髄性白血病'},
        {id: 4, name: '骨髄異形成症候群'}
      ],
      cancerType2_13Label: '血液・リンパ【悪性リンパ腫】',
      cancerType2_13: [
        {id: 1, name: '悪性リンパ腫'},
        {id: 2, name: 'ホジキンリンパ腫'},
        {id: 3, name: '非ホジキンリンパ腫（病型分類）'},
        {id: 4, name: '濾胞性リンパ腫'},
        {id: 5, name: 'MALTリンパ腫'},
        {id: 6, name: 'リンパ形質細胞性リンパ腫'},
        {id: 7, name: 'マントル細胞リンパ腫'},
        {id: 8, name: 'びまん性大細胞型B細胞リンパ腫'},
        {id: 9, name: '末梢性T細胞リンパ腫'},
        {id: 10, name: 'バーキットリンパ腫'},
        {id: 11, name: '節外性NK/T細胞リンパ腫、鼻型'},
        {id: 12, name: '皮膚のリンパ腫'},
        {id: 13, name: '慢性リンパ性白血病・小リンパ球性リンパ腫'},
        {id: 14, name: '成人T細胞白血病リンパ腫'}
      ],
      cancerType2_14Label: '血液・リンパ【その他】',
      cancerType2_14: [
        {id: 1, name: '多発性骨髄腫'}
      ],
      cancerType2_15Label: '複数の部位にまたがるものなど',
      cancerType2_15: [
        {id: 1, name: '原発不明がん'},
        {id: 2, name: '遺伝性腫瘍・家族性腫瘍'},
        {id: 3, name: '神経内分泌がん'},
        {id: 4, name: '胚細胞腫瘍（睾丸がん・精巣がん含む）'},
        {id: 5, name: '悪性中皮腫'},
        {id: 6, name: '神経内分泌腫瘍'},
        {id: 7, name: '肉腫（サルコーマ）'}
      ],
      uploadedImage: '',
      iconImageKey: '',
      iconDefaultUrl: '',
      displayName: '',
      lastName: '',
      firstName: '',
      diagnosedReason: '',
      hospitalName: '',
      cancerHistory: '',
      specialty: '',
      affiliation: '',
      businessTitle: '',
      licentiate: '',
      profile: '',
      modalMessage: '',
      modalUrl: '',
      identityId: '',
      contactUrl: '',
      showCancerType2_1: false,
      showCancerType2_2: false,
      showCancerType2_3: false,
      showCancerType2_4: false,
      showCancerType2_5: false,
      showCancerType2_6: false,
      showCancerType2_7: false,
      showCancerType2_8: false,
      showCancerType2_9: false,
      showCancerType2_10: false,
      showCancerType2_11: false,
      showCancerType2_12: false,
      showCancerType2_13: false,
      showCancerType2_14: false,
      showCancerType2_15: false,
      isLoading: true,
      isActiveButtonPrimary: true,
      isActiveButtonDisabled: false,
      isPostProcessing: false,
      isUploadImageProcessing: false,
      showDetail: false,
      appClass: '',
      consentHamaMEDResearch: '',
      patientIdHamaMEDHospital: '',
    }
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  created () {
    this.refresh()
  },

  methods: {
    refresh () {
      Storage.list('')
        .then(result => 
          this.s3Data = JSON.parse(JSON.stringify(result))
        )
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'ProfileSetting',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Image List : Storage.list',
              errorNumber: 'ProfileSetting-01',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'ProfileSetting',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image List : Storage.list',
            errorNumber: 'ProfileSetting-01',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
        })
    },

    // 画像アップロード
    upload(e) {
      this.isPostProcessing = true
      this.isActiveButtonPrimary = false
      this.isActiveButtonDisabled = true
      this.isUploadImageProcessing = true
      
      var files = e.target.files || e.dataTransfer.files
      Storage.put(this.id + "-icon-" + files[0].name, files[0], {
          level: 'protected'
        })
        .then(result => {
          //console.log(result)
          //alert(result)
          this.iconImageKey = result['key']
          this.download(this.iconImageKey)
          this.refresh()
          this.isUploadImageProcessing = false
          this.isPostProcessing = false
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
        })
        .catch(err => { 
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'ProfileSetting',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Image Upload : Storage.put',
              errorNumber: 'ProfileSetting-02',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'ProfileSetting',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image Upload : Storage.put',
            errorNumber: 'ProfileSetting-02',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          this.isUploadImageProcessing = false
          this.isPostProcessing = false
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          alert("画像のアップロードに失敗しました")
        })
    },
    download(key) {
      Storage.configure({
        level: 'protected'
      })
      Storage.get(key)
        .then(result => {
          //console.log(result)
          this.uploadedImage = result
        })
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'ProfileSetting',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Image Download : Storage.get',
              errorNumber: 'ProfileSetting-03',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'ProfileSetting',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image Download : Storage.get',
            errorNumber: 'ProfileSetting-03',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          alert("画像の取得処理に失敗しました")
        })
    },

    changeLiveInJapan: function() {
      if (this.isNotLiveInJapan) {
        this.postalCode = ''
      }
    },

    convertPostalCode: function (value) {
      // 数字以外除去
      value = value.replace(/[^0-9０-９]/g, '')

      // 半角に変換
      value = value.replace(/[０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      })
      
      return value
    },

    // 新規作成保存時
    createUserData: async function () {
      if (!this.isPostProcessing) {
        this.isPostProcessing = true
        this.isActiveButtonPrimary = false
        this.isActiveButtonDisabled = true

        // 未入力の必須項目チェック
        let alertNullItem = ''
        if (!this.displayName) {
          alertNullItem += "【表示名】が未入力です\n"
        }
        if (!this.birthDate) {
          alertNullItem += "【生年月日】が未入力です\n"
        }
        if (!this.gender) {
          alertNullItem += "【性別】が未入力です\n"
        }
        if (!this.postalCode && !this.isNotLiveInJapan) {
          alertNullItem += "【郵便番号】が未入力です\n"
        } else if (!this.isNotLiveInJapan) {
          this.postalCode = this.convertPostalCode(this.postalCode)
          if (this.postalCode.length != 7) {
            alertNullItem += "【郵便番号】の形式が不正です\n"
          }
        }
        if (alertNullItem.length > 0) {
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert("未入力項目がないか確認してください\n\n" + alertNullItem)
          return
        }
        const userData = {
          type: this.userType,
          id: this.id,
          mailAddress: this.mailaddress,
          displayName: this.displayName,
          lastName: this.lastName,
          firstName: this.firstName,
          relationship: this.relationship,
          birthDate: this.birthDate,
          gender: this.gender,
          isLiveInJapan: !this.isNotLiveInJapan,
          postalCode: this.postalCode,
          cancerType: JSON.stringify(this.checkedCancerTypes),
          cancerStage: this.cancerStage,
          diagnosedDate: this.diagnosedDate,
          diagnosedReason: this.diagnosedReason,
          hospitalName: this.hospitalName,
          curativeStatus: this.curativeStatus,
          cancerHistory: this.cancerHistory,
          diagnosedCancerType: JSON.stringify(this.checkedDiagnosedCancerType),
          specialty: this.specialty,
          affiliation: this.affiliation,
          businessTitle: this.businessTitle,
          licentiate: this.licentiate,
          profile: this.profile,
          iconImageKey: this.iconImageKey,
          iconUploadedIdentityId: this.identityId,
          iconDefaultUrl: this.iconDefaultUrl,
          isDeleted: false,
          deletedReason: null,
          deletedAt: null,
          createAt: new Date(),
          updateAt: new Date(),
          consentHamaMEDResearch: this.consentHamaMEDResearch,
          patientIdHamaMEDHospital: this.patientIdHamaMEDHospital
        }

        try {
          await API.graphql(graphqlOperation(
            createUser, { input: userData }
          ))
          alert("保存しました")
          this.$router.push({ path: '../profile/' + this.id })

        } catch (error) {
          //alert(JSON.stringify(userData))
          logger.error(JSON.stringify(error))
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'ProfileSetting',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'User Create : createUser',
              errorNumber: 'ProfileSetting-04',
              errorMessage: JSON.stringify(error)
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'ProfileSetting',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'User Create : createUser',
            errorNumber: 'ProfileSetting-04',
            errorMessage: JSON.stringify(error),
            addUser: 'system',
            createAt: new Date()
          }
          await API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert("保存に失敗しました\n未入力項目がないか確認してください\n\n" + alertNullItem)
        }

        // TODO：Adviserで新規登録をしたら、adviserAllowLists の isRegistedUser を  true に変更
      }
    },


    // 更新時
    updateUserData: async function () {
      if (!this.isPostProcessing) {
        this.isPostProcessing = true
        this.isActiveButtonPrimary = false
        this.isActiveButtonDisabled = true

        // 未入力の必須項目チェック
        let alertNullItem = ''
        if (!this.displayName) {
          alertNullItem += "【表示名】が未入力です\n"
        }
        if (!this.birthDate) {
          alertNullItem += "【生年月日】が未入力です\n"
        }
        if (!this.gender) {
          alertNullItem += "【性別】が未入力です\n"
        }
        if (!this.postalCode && !this.isNotLiveInJapan) {
          alertNullItem += "【郵便番号】が未入力です\n"
        } else if (!this.isNotLiveInJapan) {
          this.postalCode = this.convertPostalCode(this.postalCode)
          if (this.postalCode.length != 7) {
            alertNullItem += "【郵便番号】の形式が不正です\n"
          }
        }

        if (alertNullItem.length > 0) {
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert("未入力項目がないか確認してください\n\n" + alertNullItem)
          return
        }
        const userData = {
          type: this.userType,
          id: this.id,
          mailAddress: this.mailaddress,
          displayName: this.displayName,
          lastName: this.lastName,
          firstName: this.firstName,
          relationship: this.relationship,
          birthDate: this.birthDate,
          gender: this.gender,
          isLiveInJapan: !this.isNotLiveInJapan,
          postalCode: this.postalCode,
          cancerType: JSON.stringify(this.checkedCancerTypes),
          cancerStage: this.cancerStage,
          diagnosedDate: this.diagnosedDate,
          diagnosedReason: this.diagnosedReason,
          hospitalName: this.hospitalName,
          curativeStatus: this.curativeStatus,
          cancerHistory: this.cancerHistory,
          diagnosedCancerType: JSON.stringify(this.checkedDiagnosedCancerType),
          specialty: this.specialty,
          affiliation: this.affiliation,
          businessTitle: this.businessTitle,
          licentiate: this.licentiate,
          profile: this.profile,
          iconImageKey: this.iconImageKey,
          iconUploadedIdentityId: this.identityId,
          //isDeleted: false,
          //deletedReason: null,
          //deletedAt: null,
          //createAt: '2020-09-12T15:12:00+09:00',
          updateAt: new Date(),
          consentHamaMEDResearch: this.consentHamaMEDResearch,
          patientIdHamaMEDHospital: this.patientIdHamaMEDHospital
        }

        try {
          await API.graphql(graphqlOperation(
            updateUser, { input: userData }
          ))
          alert("更新しました")
          this.$router.push({ path: '../profile/' + this.id })

        } catch (error) {
          logger.error(JSON.stringify(error))
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'ProfileSetting',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'User Update : updateUser',
              errorNumber: 'ProfileSetting-05',
              errorMessage: JSON.stringify(error)
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'ProfileSetting',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'User Update : updateUser',
            errorNumber: 'ProfileSetting-05',
            errorMessage: JSON.stringify(error),
            addUser: 'system',
            createAt: new Date()
          }
          await API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert("保存に失敗しました\n未入力項目がないか確認してください\n\n" + alertNullItem)
        }
      }
    }
  },

  mounted : function(){
    this.appClass = this.getAppDivClass(location.hostname)
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email

      let currentCredentials = await Auth.currentCredentials()
      this.identityId = currentCredentials.identityId
    } catch (err) {
      this.signedIn = false
    }

    // 招待コード認証が未登録の場合はDashboardに戻す
    if (this.getInvitationCodeActiveStatus(location.hostname)) {
      try {
        let invitationAllowData = await API.graphql(
          graphqlOperation(listInvitationAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          invitationAllowData.data.listInvitationAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 認証済み
        } else {
          this.$router.push({ path: '../dashboard' })
        }
      } catch (err) {
        this.$router.push({ path: '../dashboard' })
      }
    }
    
    // 認証情報でUserデータを確認
    try {
      let userData = await API.graphql(
        graphqlOperation(listUsersBySpecificUser, {
          mailAddress: this.mailaddress,
          limit: 1
        })
      )
      this.userType = userData.data.listUsersBySpecificUser.items[0].type
      this.displayName = userData.data.listUsersBySpecificUser.items[0].displayName
      this.lastName = userData.data.listUsersBySpecificUser.items[0].lastName
      this.firstName = userData.data.listUsersBySpecificUser.items[0].firstName
      this.relationship = userData.data.listUsersBySpecificUser.items[0].relationship
      if (userData.data.listUsersBySpecificUser.items[0].birthDate !== '0000-01-01') {
        this.birthDate = userData.data.listUsersBySpecificUser.items[0].birthDate
      } else {
        this.birthDate = null
      }
      if (userData.data.listUsersBySpecificUser.items[0].gender !== '-') {
        this.gender = userData.data.listUsersBySpecificUser.items[0].gender
      } else {
        this.gender = null
      }
      this.isNotLiveInJapan = !userData.data.listUsersBySpecificUser.items[0].isLiveInJapan
      if (userData.data.listUsersBySpecificUser.items[0].postalCode !== '-') {
        this.postalCode = userData.data.listUsersBySpecificUser.items[0].postalCode
      } else {
        this.postalCode = null
      }
      if (userData.data.listUsersBySpecificUser.items[0].cancerType !== '""') {
        this.checkedCancerTypes = JSON.parse(userData.data.listUsersBySpecificUser.items[0].cancerType)
      } else {
        this.checkedCancerTypes = null
      }
      this.cancerStage = userData.data.listUsersBySpecificUser.items[0].cancerStage
      this.diagnosedDate = userData.data.listUsersBySpecificUser.items[0].diagnosedDate
      this.diagnosedReason = userData.data.listUsersBySpecificUser.items[0].diagnosedReason
      this.hospitalName = userData.data.listUsersBySpecificUser.items[0].hospitalName
      this.curativeStatus = userData.data.listUsersBySpecificUser.items[0].curativeStatus
      this.cancerHistory = userData.data.listUsersBySpecificUser.items[0].cancerHistory
      if (userData.data.listUsersBySpecificUser.items[0].diagnosedCancerType !== '""') {
        this.checkedDiagnosedCancerType = JSON.parse(userData.data.listUsersBySpecificUser.items[0].diagnosedCancerType)
      } else {
        this.checkedDiagnosedCancerType = null
      }
      this.specialty = userData.data.listUsersBySpecificUser.items[0].specialty
      this.affiliation = userData.data.listUsersBySpecificUser.items[0].affiliation
      this.businessTitle = userData.data.listUsersBySpecificUser.items[0].businessTitle
      this.licentiate = userData.data.listUsersBySpecificUser.items[0].licentiate
      this.profile = userData.data.listUsersBySpecificUser.items[0].profile
      this.iconImageKey = userData.data.listUsersBySpecificUser.items[0].iconImageKey
      if (this.iconImageKey) {
        this.uploadedImage = this.download(this.iconImageKey)
      }
      this.iconUploadedIdentityId = userData.data.listUsersBySpecificUser.items[0].iconUploadedIdentityId

      // iconDefaultUrlが空の場合、デフォルト画像からランダムに初期値設定
      if (!userData.data.listUsersBySpecificUser.items[0].iconDefaultUrl) {
        let random = ('0' + (Math.floor(Math.random() * (10)) + 1)).slice(-2)
        this.iconDefaultUrl = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/salmi' + random + '.png'
      } else {
        this.iconDefaultUrl = userData.data.listUsersBySpecificUser.items[0].iconDefaultUrl
      }

      this.consentHamaMEDResearch = userData.data.listUsersBySpecificUser.items[0].consentHamaMEDResearch
      this.patientIdHamaMEDHospital = userData.data.listUsersBySpecificUser.items[0].patientIdHamaMEDHospital

      if (userData.data.listUsersBySpecificUser.items[0].type === 'adviser') {
        this.isAdviser = true
      } else {
        this.isAdviser = false
      }
      if (userData.data.listUsersBySpecificUser.items[0].id) {
        this.hasUserData = true
      }
      let env = this.getEnv(location.hostname)
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // 浜松オンラインがん相談版
      } else {
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // CancerWith版
      }
      this.isLoading = false
    } catch (err) {
      // 運営アカウントか判定
      try {
        let staffAllowData = await API.graphql(
          graphqlOperation(listStaffAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 運営モード
          this.userId = ''
          this.userType = 'adviser'
          this.isAdviser = false
          this.isStaff = true
          this.hasUserData = true
          this.contactUrl = ''
          this.isLoading = false
        } else {
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
          this.isLoading = false
        }
      } catch (err) {
        this.userId = ''
        this.userType = ''
        this.isAdviser = false
        this.isStaff = false
        this.hasUserData = false
        this.contactUrl = ''
        this.isLoading = false

        // デフォルト画像からランダムに初期値設定
        let random = ('0' + (Math.floor(Math.random() * (10)) + 1)).slice(-2)
        this.iconDefaultUrl = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/salmi' + random + '.png'
      }
    }

    // userTypeが空の場合 = 新規登録の場合、アドバイザー許可リストテーブル（adviser_allow_lists）
    // にメールアドレスの指定があれば userTypeはadviser、それ以外はuser
    if (this.hasUserData === false) {
      try {
        let adviserAllowData = await API.graphql(
          graphqlOperation(listAdviserAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )

        if (
          adviserAllowData.data.listAdviserAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          this.userType = 'adviser'
          this.isAdviser = true
        } else {
          this.userType = 'user'
          this.isAdviser = false
        }
      } catch (err) {
        this.userType = 'user'
        this.isAdviser = false
      }
    }
    
    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'ProfileSetting',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: this.userType
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      if (this.userType === 'user') {
        this.$gtag.pageview({
          page_path: '/user/profileSetting',
          page_title: 'User:プロフィール設定 (/profileSetting)'
        })
      } else if (this.userType === 'adviser') {
        this.$gtag.pageview({
          page_path: '/adviser/profileSetting',
          page_title: 'Adviser:プロフィール設定 (/profileSetting)'
        })
      }
    }
  }
}
</script>
<style>
</style>
<style src="./assets/style.css" />
